import { useLocation, Link } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[60vh] w-full flex-col items-center justify-center px-4 py-20 text-center">
      <p className="font-heading text-6xl font-black text-background-200 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        页面走丢了
      </h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你访问的页面「{location.pathname}」不存在或已被移除。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/movies/popular"
          className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          浏览热门影片
        </Link>
      </div>
    </div>
  );
}